<template>
  <div class="user-list-box">
    <OperationBoxComponent :actions="actions" :filters="filters" :disabled="params.ids.length === 0" />
    <ParseListComponent :page-data="pageData" @onSelectChanged="onSelectChanged" @onPageChanged="onPageChanged" />
  </div>
</template>

<script>
import OperationBoxComponent from '../../../components/common/OperationBoxComponent'
import {WaterMarkerRequestUtil} from '../../../utils/WaterMarkerRequestUtil'
import ParseListComponent from '../../../components/parse/ParseListComponent'

export default {
  name: 'WaterMarkerListPage',
  components: {
    ParseListComponent,
    OperationBoxComponent
  },
  mounted () {
    this.updateList()
  },
  data () {
    return {
      actions: [
        { title: '', disabled: false, icon: 'el-icon-refresh', type: 'button', theme: 'primary', action: this.updateList },
        { title: '类型',
          type: 'select',
          action: this.onTypeChange,
          options: [
            {title: '图片', value: 2},
            {title: '视频', value: 4}
          ]}
      ],
      filters: [],
      pageData: {},
      params: {
        ids: []
      },
      queryParam: {
        page: 1,
        pageSize: 25,
        type: null
      }
    }
  },
  methods: {
    updateList () {
      let that = this
      WaterMarkerRequestUtil.queryList({queryParam: this.queryParam}, function (response) {
        if (response.items) {
          that.pageData = response
        }
      })
    },
    onTypeChange (item) {
      this.queryParam.type = item.selectValue
      this.updateList()
    },
    onPageChanged (page) {
      this.queryParam.page = page
      this.updateList()
    },
    onSelectChanged (ids) {
      this.params.ids = ids
    }
  }
}
</script>

<style scoped lang="less">

</style>



// WEBPACK FOOTER //
// src/pages/whaledge/watermarker/WaterMarkerListPage.vue